import { AxiosError } from 'axios';
import instance from '../config/axios';

export const fetchDosageDiaryProfiles = async (token: string) => {
  try {
    const response = await instance({
      url: '/api/v1/dosasgedairy/profile',
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (e) {
    return (e as AxiosError).response?.status;
  }
};
